import { render, staticRenderFns } from "./LiveSessionDetail.vue?vue&type=template&id=5e2365a1&scoped=true&"
import script from "./LiveSessionDetail.vue?vue&type=script&lang=js&"
export * from "./LiveSessionDetail.vue?vue&type=script&lang=js&"
import style0 from "./LiveSessionDetail.vue?vue&type=style&index=0&id=5e2365a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2365a1",
  null
  
)

export default component.exports